import { Search } from "lucide-react";
import type { ChangeEvent } from "react";

type Props = {
  value: string;
  onChange: (v: string) => void;
};

export function SearchBar({ value, onChange }: Props) {
  return (
    <div className="relative">
      <Search
        size={14}
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[var(--color-ink-muted)]"
      />
      <input
        type="search"
        placeholder="キー・値を検索..."
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        className="h-9 w-full rounded-[10px] border border-[var(--color-border)] bg-[var(--color-surface)] pl-9 pr-3 text-sm focus:border-[var(--color-coral)] focus:outline-none"
      />
    </div>
  );
}
